'use client';
import React, { useState, useEffect } from 'react';
import './StickySidebarCTA.css';

export default function StickySidebarCTA() {
    const [visible, setVisible] = useState(false);
    const [atBottom, setAtBottom] = useState(false);
    const timerRef = React.useRef(null);
    const hoveredRef = React.useRef(false);
    const hasShownRef = React.useRef(false);

    useEffect(() => {
        const handler = () => {
            const scrollY = window.scrollY;
            const winH = window.innerHeight;
            const docH = document.documentElement?.scrollHeight;

            const heroElement = document.getElementById('hero');
            const heroHeight = heroElement ? heroElement.offsetHeight + heroElement.offsetTop : winH * 0.8;

            const isPastHero = scrollY > heroHeight;

            if (isPastHero && !hasShownRef.current) {
                hasShownRef.current = true;
                setVisible(true);
                timerRef.current = setTimeout(() => {
                    if (!hoveredRef.current) {
                        setVisible(false);
                    }
                }, 6000);
            }

            setAtBottom(scrollY + winH > docH - 200);
        };

        window.addEventListener('scroll', handler, { passive: true });
        handler();

        return () => {
            window.removeEventListener('scroll', handler);
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, []);

    const handleMouseEnter = () => {
        hoveredRef.current = true;
        if (timerRef.current) clearTimeout(timerRef.current);
        setVisible(true);
    };

    const handleMouseLeave = () => {
        hoveredRef.current = false;
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            setVisible(false);
        }, 6000);
    };

    if (atBottom) return null;

    return (
        <div
            className={`sidebar-cta-wrapper ${visible ? 'is-visible' : 'is-hidden'}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <a
                href="https://wa.me/8688090217"
                target="_blank"
                rel="noopener noreferrer"
                className="sidebar-cta-btn"
                aria-label="Chat on WhatsApp"
                style={{ textDecoration: 'none' }}
            >
                <div className="cta-line-top" />
                <div className="cta-btn-circle btn-pulse" style={{ backgroundColor: 'var(--cta-teal)' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                        <path d="M12.01 2.002c-5.5 0-9.98 4.48-9.98 9.98 0 1.76.46 3.42 1.28 4.88L2 22l5.3-1.33c1.42.78 3.03 1.22 4.71 1.22 5.5 0 9.98-4.48 9.98-9.98s-4.48-9.98-9.98-9.98zm5.54 14.18c-.24.67-1.36 1.25-1.92 1.33-.53.08-1.22.18-3.32-.69-2.52-1.05-4.14-3.63-4.26-3.8-.12-.16-1.02-1.36-1.02-2.6 0-1.24.64-1.85.87-2.09.22-.23.49-.29.65-.29.16 0 .32.01.46.01.17 0 .4-.06.63.48.24.56.78 1.93.84 2.06.07.13.12.29.04.45-.07.16-.12.26-.23.39-.12.12-.25.28-.35.39-.11.12-.24.25-.1.49.13.23.59 1 1.26 1.59.86.76 1.6 1 1.84 1.11.23.11.37.09.5-.06.13-.15.58-.68.73-.91.16-.24.31-.2.53-.12.22.08 1.4.67 1.64.79.24.12.4.18.45.28.06.11.06.61-.18 1.28z" />
                    </svg>
                </div>
                <span
                    className="cta-text-vertical"
                    style={{ writingMode: 'vertical-rl', textOrientation: 'mixed', transform: 'rotate(180deg)' }}
                >
                    WhatsApp
                </span>
                <div className="cta-line-bottom" />
            </a>
        </div>
    );
}
